import { DestroyRef, inject, Injectable } from '@angular/core';
import { CookieFacade } from '@lentau/ui-kit/core/services/cookie/cookie.facade';
import { GrowthBookExperimentsCookie } from './constants';
import { DateUtils } from '@lentau/ui-kit/core/utils/date.utils';
import { FeatureDefinition, FeatureResult, GrowthBook } from '@growthbook/growthbook';
import { GrowthBookService } from '@lentau/core/growth-book/shared/growth-book.service';
import { ExperimentsMap, GBFeatureValue } from '@lentau/core/growth-book/shared/interfaces';
import { take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class GrowthBookExperimentsService {
  private growthBookService: GrowthBookService = inject(GrowthBookService);
  private cookieService: CookieFacade = inject(CookieFacade);
  private destroyRef: DestroyRef = inject(DestroyRef);

  public setAnalyticsByExperiments(): void {
    this.growthBookService.isInitialized$
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.getExperimentsForAnalytic());
  }

  private getExperimentsForAnalytic(): void {
    const growthBook: GrowthBook<Record<string, GBFeatureValue>> | undefined = this.growthBookService.getGrowBook();
    if (!growthBook) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const features: Record<string, FeatureDefinition<any>> = growthBook.getFeatures();
    const activeExperiments: ExperimentsMap = new Map([]);

    for (const featureKey of Object.keys(features)) {
      const result: FeatureResult<GBFeatureValue> = growthBook.evalFeature(featureKey);

      // Если фича активна и значение не дефолтное (пользователь попал в эксперимент)
      if (result.source === 'experiment') {
        activeExperiments.set(result.experiment.key, result.experimentResult.variationId);
      }
    }

    this.setCookieForAnalytics(activeExperiments);
  }

  private setCookieForAnalytics(experiments: ExperimentsMap): void {
    const results: string[] = [];

    if (experiments?.size) {
      experiments.forEach((value: GBFeatureValue, key: string) => {
        results.push(`${key}.${value}`);
      });

      this.cookieService.set(GrowthBookExperimentsCookie, results.length ? results.join(',') : '', {
        path: '/',
        expires: DateUtils.addDays(new Date(), 360),
      });
    }
  }
}
